import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheck, Route as RouteIcon, Compass, ArrowRight, Sparkles, Presentation } from 'lucide-react';

const FICHES = [
  {
    to: '/cours/premiere-circulation-a2',
    title: 'Ma 1ʳᵉ circulation A2',
    badge: 'Cours premium · 14 chapitres',
    desc: '14 chapitres pédagogiques illustrés pour la 1ʳᵉ leçon sur route : préparation, groupe & radio, méthode d\'intersection et de giratoire, bilan et les 7 réflexes CODE 2 ROUES. Consultable en mode lecture ou en présentation plein écran.',
    icon: Presentation,
    testid: 'card-cours-premiere-circulation',
    premium: true,
  },
  {
    to: '/cours/deuxieme-circulation-a2',
    title: 'Ma 2ᵉ circulation A2',
    badge: 'Cours premium · Séance 2',
    desc: 'Observer • Anticiper • Adapter. 14 chapitres pour la 2ᵉ leçon : regard qui prend de l\'avance, recherche des indices, espace de sécurité, giratoires en autonomie, lecture des véhicules, guidage progressif.',
    icon: Presentation,
    testid: 'card-cours-deuxieme-circulation',
    premium: true,
  },
  {
    to: '/cours/troisieme-circulation-a2',
    title: 'Ma 3ᵉ circulation A2',
    badge: 'Cours premium · Séance 3',
    desc: 'Décider • Planifier • S\'adapter • Devenir autonome. 14 chapitres pour la 3ᵉ leçon : regard loin, hiérarchisation des risques, positionnement stratégique, dépassement, virages autonomes, prise de décision.',
    icon: Presentation,
    testid: 'card-cours-troisieme-circulation',
    premium: true,
  },
  {
    to: '/cours/quatrieme-circulation-a2',
    title: 'Ma 4ᵉ circulation A2',
    badge: 'Cours premium · Séance 4',
    desc: 'Conduire • Anticiper • Choisir • Sécuriser • Être autonome. 14 chapitres pour la 4ᵉ leçon : autonomie continue, suivi de direction, imprévu, savoir renoncer, partage, courtoisie, régularité, auto-analyse — proche du niveau examen.',
    icon: Presentation,
    testid: 'card-cours-quatrieme-circulation',
    premium: true,
  },
  {
    to: '/cours/cinquieme-circulation-a2',
    title: 'Ma 5ᵉ circulation A2',
    badge: 'Cours premium · Séance 5',
    desc: 'Consolider • S\'adapter • Rester régulier • Se rapprocher du niveau examen. 14 chapitres pour la 5ᵉ leçon : autonomie immédiate, itinéraire, marges, situations complexes, voie rapide, récupération, séquence type examen et auto-débriefing.',
    icon: Presentation,
    testid: 'card-cours-cinquieme-circulation',
    premium: true,
  },
  {
    to: '/cours/sixieme-circulation-a2',
    title: 'Ma 6ᵉ circulation A2',
    badge: 'Cours premium · Séance 6 · FINAL',
    desc: 'Valider • Consolider • Être autonome • Se préparer à l\'examen. 14 chapitres pour la dernière séance (12 h minimales atteintes) : mobilisation complète, environnements variés, autonomie prolongée, séquence conditions d\'évaluation, auto-bilan et bilan final à 3 niveaux (autonome / consolider / travailler).',
    icon: Presentation,
    testid: 'card-cours-sixieme-circulation',
    premium: true,
  },
  {
    to: '/cours/premiere-plateau-a2',
    title: 'Ma 1ʳᵉ séance plateau A2',
    badge: 'Cours plateau premium · Séance 1',
    desc: 'Tu découvres • Tu ressens • Tu contrôles ta moto. 14 chapitres : commandes, installation, point de patinage, coordination, regard, allure lente, premier demi-tour, changement de rapports, premier freinage maîtrisé.',
    icon: Presentation,
    testid: 'card-cours-premiere-plateau',
    premium: true,
  },
  {
    to: '/cours/deuxieme-plateau-a2',
    title: 'Ma 2ᵉ séance plateau A2',
    badge: 'Cours plateau premium · Séance 2',
    desc: 'Tu stabilises • Tu coordonnes • Tu diriges • Tu gagnes en précision. 14 chapitres : allure lente stable, coordination, regard anticipateur, demi-tour précis, portes, arrêts précis, transitions.',
    icon: Presentation,
    testid: 'card-cours-deuxieme-plateau',
    premium: true,
  },
  {
    to: '/cours/troisieme-plateau-a2',
    title: 'Ma 3ᵉ séance plateau A2',
    badge: 'Cours plateau premium · Séance 3',
    desc: 'Tu accélères • Tu freines • Tu évites • Tu enchaînes. 14 chapitres : transitions lent/dynamique, freinage progressif, évitement (regard, contre-braquage, retour) et premiers enchaînements complets.',
    icon: Presentation,
    testid: 'card-cours-troisieme-plateau',
    premium: true,
  },
  {
    to: '/cours/quatrieme-plateau-a2',
    title: 'Ma 4ᵉ séance plateau A2',
    badge: 'Cours plateau premium · Séance 4 · FINAL',
    desc: 'Tu consolides • Tu enchaînes • Tu t\'auto-corriges • Tu deviens autonome. 14 chapitres : régularité, passager, reproductibilité, auto-correction, bilan final à 3 niveaux. 8 h minimales atteintes.',
    icon: Presentation,
    testid: 'card-cours-quatrieme-plateau',
    premium: true,
  },
  {
    to: '/epreuves/plateau',
    title: 'Épreuve Plateau Moto',
    badge: '6 manœuvres · 5 phases',
    desc: "Maîtrise de la moto sans l'aide du moteur, allure réduite, freinage d'urgence, slalom et évitement à allure élevée. Évaluation A/B/C.",
    icon: ClipboardCheck,
    testid: 'card-plateau',
  },
  {
    to: '/epreuves/circulation',
    title: 'Épreuve en Circulation',
    badge: '~35 min · barème /27',
    desc: "7 compétences dynamiques (positionnement, prise d'information, allure, réglementation, communication, partage, sécurité) + 3 transversales. Total 21/27.",
    icon: RouteIcon,
    testid: 'card-circulation',
  },
  {
    to: '/epreuves/trajectoires',
    title: 'Trajectoires de sécurité',
    badge: 'Atelier dessin',
    desc: "3 situations type (virage en S, épingle, carrefour à sens giratoire) où l'élève trace lui-même sa trajectoire et la sauvegarde pour révision.",
    icon: Compass,
    testid: 'card-trajectoires',
  },
];

export default function EpreuvesHub() {
  return (
    <div className="space-y-6" data-testid="epreuves-hub">
      <section className="mc-card relative overflow-hidden p-6 sm:p-8" data-testid="epreuves-hero">
        <div className="pointer-events-none absolute -top-20 -right-20 w-72 h-72 rounded-full blur-3xl opacity-20" style={{ background: 'hsl(var(--primary))' }} aria-hidden="true" />
        <div className="relative">
          <div className="inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-[0.18em] mb-2 px-2.5 py-1 rounded-full" style={{ background: 'hsl(var(--primary) / 0.10)', color: 'hsl(var(--primary))' }}>
            <Sparkles className="w-3 h-3" /> Programme officiel — Épreuves pratiques
          </div>
          <h1 className="text-2xl sm:text-4xl font-black tracking-tight leading-tight">Les épreuves pratiques moto, expliquées étape par étape.</h1>
          <p className="text-sm sm:text-[15px] text-muted-foreground mt-2 max-w-3xl leading-relaxed">
            Trois fiches pédagogiques interactives pour comprendre exactement à quoi t'attendre le jour&nbsp;J : déroulé,
            critères d'évaluation et trajectoires de sécurité. Tu peux <strong>cocher tes acquis</strong> et <strong>dessiner</strong> tes trajectoires.
            Tout est sauvegardé localement.
          </p>
        </div>
      </section>

      <section className="grid md:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="epreuves-cards">
        {FICHES.map((f) => {
          const Icon = f.icon;
          const isPremium = f.premium;
          return (
            <Link
              to={f.to}
              key={f.to}
              className={`c2r-fiche-card mc-card p-5 hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-200 group block ${
                isPremium ? 'border-2 border-red-500/40 bg-gradient-to-br from-red-600/10 via-red-500/5 to-transparent hover:border-red-500/70' : ''
              }`}
              data-testid={f.testid}
            >
              {isPremium && (
                <div className="inline-flex items-center gap-1.5 text-[9px] font-black uppercase tracking-[0.22em] mb-2 px-2 py-0.5 rounded-full bg-red-500/20 text-red-400 border border-red-500/30">
                  <Sparkles className="w-3 h-3" /> Nouveau · Premium
                </div>
              )}
              <div className="relative z-[1] flex items-start gap-3 mb-3">
                <div
                  className="c2r-fiche-icon w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{
                    background: isPremium ? 'rgba(239, 68, 68, 0.15)' : 'hsl(var(--primary) / 0.10)',
                    color: isPremium ? '#ef4444' : 'hsl(var(--primary))',
                  }}
                >
                  <Icon className="w-6 h-6" />
                </div>
                <div className="flex-1 min-w-0">
                  <div
                    className="text-[10px] font-black uppercase tracking-widest mb-0.5"
                    style={{ color: isPremium ? '#ef4444' : 'hsl(var(--primary))' }}
                  >
                    {f.badge}
                  </div>
                  <h2 className="text-base sm:text-lg font-black leading-tight">{f.title}</h2>
                </div>
              </div>
              <p className="relative z-[1] text-sm text-muted-foreground leading-relaxed">{f.desc}</p>
              <div
                className="relative z-[1] mt-4 inline-flex items-center gap-1.5 text-sm font-bold group-hover:gap-2.5 transition-all"
                style={{ color: isPremium ? '#ef4444' : 'hsl(var(--primary))' }}
              >
                {isPremium ? 'Ouvrir le cours' : 'Ouvrir la fiche'} <ArrowRight className="w-4 h-4" />
              </div>
            </Link>
          );
        })}
      </section>

      <section className="mc-card p-5 sm:p-6 text-sm text-foreground/85 leading-relaxed" data-testid="epreuves-disclaimer">
        <div className="text-[10px] font-black uppercase tracking-widest text-muted-foreground mb-2">À retenir</div>
        Ces fiches reprennent la structure des épreuves moto définies par le programme officiel (arrêté du <strong>23 avril 2012</strong>, REMC).
        Elles sont mises à disposition à titre <strong>pédagogique</strong> et ne remplacent pas le déroulé fourni par ton inspecteur le jour de l'examen.
      </section>
    </div>
  );
}
